
import PaymentSource from "@/api/PaymentSource.js";

export const paymentModule = {
    state: () => ({
        error: false,
        isLoader: false,
        payment_method: 'rbs',
        payments: null,
    }),
    mutations: {
        setPayments(state, data) {
            data.forEach(payment => {
                if(payment.selected){
                    state.payment_method = payment.code
                }
            });
            state.payments = data;
        },
        setPaymentMethod(state, data) {
            state.payment_method = data;
        },
        setError(state, data) {
            state.error = data;
        },
        setLoader(state, value) {
            state.isLoader = value;
        },
    },
    getters: {

    },
    actions: {
        async loadList({commit}) {
            commit('setLoader', true);
            await  this.$API.manager.getSource(PaymentSource).list().then((response) => {
                commit('setPayments', response);

            }).catch(() => {
                commit('setPayments', []);
            }).finally(() => {
                commit('setLoader', false);
            })
        },
        async initPaymentMethod({commit}, value) {
            commit('setLoader', true);
            await  this.$API.manager.getSource(PaymentSource).setMethod({ payment_method: value }).then((response) => {
                commit('setPaymentMethod', response.payment_method.code);
            }).catch(() => {
                commit('setPaymentMethod', null);
            }).finally(() => {
                commit('setLoader', false);
            })
        },
        async deleteCard({commit, dispatch}, cardId) {
            commit('setLoader', true);
            try {
                await this.$API.manager.getSource(PaymentSource).deleteCard(cardId);
                await dispatch('loadList');
            } catch (e) {
                commit('setError', e?.message || 'Ошибка удаления карты');
            } finally {
                commit('setLoader', false);
            }
        }
    },
    namespaced: true
}
